export const UPSERT_PERMISSION_ATTRIBUTES_CONSTANT = {
  name: {
    type: 'text',
    key: 'name',
    label: 'Permission Category Name',
  },
  description: {
    type: 'text',
    key: 'description',
    label: 'Permission Category Description',
  },
  selectionOrder: {
    type: 'number',
    key: 'selection_order',
    label: 'Permission Category Order',
  },
  isCollapsible: {
    type: 'checkbox',
    key: 'is_collapsible',
    label: 'Is Collapsable',
  },
  isActive: {
    type: 'checkbox',
    key: 'is_active',
    label: 'Is Active',
  },
  permData: {
    title: {
      type: 'text',
      key: 'title',
      label: 'Permission Name',
    },
    slug: {
      type: 'text',
      key: 'slug',
      label: 'Slug',
    },
    permissionType: {
      type: 'text',
      key: 'permission_type',
      label: 'Permission Type',
    },
    description: {
      type: 'text',
      key: 'description',
      label: 'Description',
    },
    apiEndpoint: {
      type: 'text',
      key: 'api_endpoint',
      label: 'API Endpoint',
    },
    displayInMenu: {
      type: 'checkbox',
      key: 'display_in_menu',
      label: 'Display In Menu',
    },
    isActive: {
      type: 'checkbox',
      key: 'is_active',
      label: 'Is Active',
    },
  },
} as const;

export const PERMISSION_TYPE = [
  { value: 'url', name: 'URL' },
  { value: 'clickAction', name: 'Click Action' },
  { value: 'apiData', name: 'API Data' },
];
